import gsap, { SplitText } from "@lib/gsap";
import { onMount, onView, onTrack, onDestroy, onPageIn, onPageOut } from "./_";
import { Scroll } from "@/lib/scroll";

export default function (element, dataset) {
  const list = element.querySelector('[fs-list-element="list"]');
  if (!list) return;

  const observer = new MutationObserver(() => {
    Scroll.resize();
    console.log("refreshed");
  });

  observer.observe(list, { childList: true });
}
